import React from "react";
import "../assets/css/capacityNotice.css";

const CapacityNoticeModal = ({
  open,
  title = "Capacity exceeded",
  message,
  rows,
  hint,
  onClose,
}) => {
  if (!open) return null;

  const parsed = String(message || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .reduce(
      (acc, line) => {
        const sep = line.indexOf(":");
        if (sep > 0 && sep < 28) {
          acc.rows.push({
            label: line.slice(0, sep).trim(),
            value: line.slice(sep + 1).trim(),
          });
        } else if (!acc.intro) {
          acc.intro = line;
        } else {
          acc.hint = line;
        }
        return acc;
      },
      { intro: "", rows: [], hint: "" }
    );

  const intro = Array.isArray(rows) && rows.length ? message : parsed.intro || (!parsed.rows.length ? message : "");
  const detailRows = Array.isArray(rows) && rows.length ? rows : parsed.rows;
  const footerHint = hint || parsed.hint;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
            />
          </div>
          <div className="modal-body">
            {intro ? (
              <p className={detailRows.length || footerHint ? "mb-3" : "mb-0"}>
                {intro}
              </p>
            ) : null}
            {detailRows.length ? (
              <dl
                className={`capacity-notice-rows${footerHint ? " mb-3" : " mb-0"}`}
              >
                {detailRows.map((row) => (
                  <div className="capacity-notice-row" key={row.label}>
                    <dt>{row.label}</dt>
                    <dd>{row.value}</dd>
                  </div>
                ))}
              </dl>
            ) : null}
            {footerHint ? <p className="mb-0 text-muted">{footerHint}</p> : null}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={onClose}>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapacityNoticeModal;
